import Immutable from 'immutable';
import {
    INJECT_HOMEBASES,
    IS_FETCH_HOMEBASE_IN_PROGRESS
} from 'common/constants/actionTypes';
import { Homebase } from 'common/models/internal/Homebase';

const homebase = (state = Immutable.fromJS({}), action) => {
    switch (action.type) {
        case INJECT_HOMEBASES: {
            var homebasesResponse = action.response;
            const { clientId } = action.params;
            var homebases = new Immutable.List();
            homebasesResponse.forEach(homebase => {
                homebases = homebases.push(Homebase.fromJS(homebase));
            });
            return state.setIn(['records', clientId], homebases);
        }

        case IS_FETCH_HOMEBASE_IN_PROGRESS: {
            const isFetchHomebaseInProgress = action.response;
            const { clientId } = action.params;
            return state.setIn(
                [clientId, 'isFetchHomebaseInProgress'],
                isFetchHomebaseInProgress
            );
        }

        default:
            return state;
    }
};

export default homebase;
